var _title, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClosedRejected = function SvgClosedRejected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "style-three-pin-block")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round",
    fill: "white",
    d: "M12,0C6.21,0,1.5,4.262,1.5,9.5c0,5.747,7.3,12.285,9.54,14.152a1.5,1.5,0,0,0,1.921,0C15.2,21.784,22.5,15.246,22.5,9.5,22.5,4.262,17.79,0,12,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92,6.52a.25.25,0,0,0-.038-.385A5.168,5.168,0,0,0,12,5.25,5.256,5.256,0,0,0,6.75,10.5a5.168,5.168,0,0,0,.885,2.882.249.249,0,0,0,.183.11.252.252,0,0,0,.2-.072Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08,14.48a.252.252,0,0,0-.072.2.249.249,0,0,0,.11.183A5.168,5.168,0,0,0,12,15.75a5.256,5.256,0,0,0,5.25-5.25,5.168,5.168,0,0,0-.885-2.882.249.249,0,0,0-.183-.11.252.252,0,0,0-.2.072Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C6.21,0,1.5,4.262,1.5,9.5c0,5.747,7.3,12.285,9.54,14.152a1.5,1.5,0,0,0,1.921,0C15.2,21.784,22.5,15.246,22.5,9.5,22.5,4.262,17.79,0,12,0Zm0,17.25a6.75,6.75,0,1,1,6.75-6.75A6.758,6.758,0,0,1,12,17.25Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosedRejected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed_rejected.cb7d4932.svg";
export { ForwardRef as ReactComponent };